(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreinteDetailController', AstreinteDetailController);

    AstreinteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Astreinte'];

    function AstreinteDetailController($scope, $rootScope, $stateParams, previousState, entity, Astreinte) {
        var vm = this;

        vm.astreinte = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('tmgApp:astreinteUpdate', function(event, result) {
            vm.astreinte = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
